module.exports = __webpack_public_path__ + "c10a05ce31f693487a4876b1d1bce1.svg";